import TableSectionSkeleton from '../../../Skeletons/TableSectionSkeleton'
import TableSwitch from '../components/TableSwitch'
import useSelection from '../components/use-table-switch'
import useData from './use-data'

const TableSsids = ({viewType, verbatim}) => {
  const {data, loading} = useData()
  const selectionApi = useSelection({viewType, loading, sites: [], ssids: data})

  if (loading) {
    return <TableSectionSkeleton />
  }
  return <TableSwitch verbatim={verbatim} viewType={viewType} selectionApi={selectionApi} />
}

export default TableSsids